export interface ServiceStructuredData {
  "@context": "https://schema.org/";
  "@type": "Service";
  serviceType: string;
  provider: {
    "@type": "Organization";
    name: "TaskRabbit";
  };
}

interface BuildServiceStructuredDataArgs {
  serviceType: string;
}

export function buildServiceStructuredData({
  serviceType,
}: BuildServiceStructuredDataArgs): ServiceStructuredData {
  return {
    "@context": "https://schema.org/",
    "@type": "Service",
    serviceType,
    provider: {
      "@type": "Organization",
      name: "TaskRabbit",
    },
  };
}
